import { render } from "./dailyneed.vue?vue&type=template&id=89e8708e&scoped=true"
import script from "./dailyneed.vue?vue&type=script&lang=js"
export * from "./dailyneed.vue?vue&type=script&lang=js"

import "./dailyneed.vue?vue&type=style&index=0&id=89e8708e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e8708e"]])

export default __exports__